import { makeObservable, observable, flow, action } from "mobx";
import sensecommon from "@sensechat/user-inteceptor";
import { checkVideoEditWhitelist } from "logic/src/services/videoEdit";
// import {
//   GoogleAuthProvider,
//   getAuth,
//   signInWithPopup,
//   OAuthProvider,
//   onAuthStateChanged,
//   signOut,
// } from "firebase/auth";
// import { firebaseConfig } from "../../constants/filrebase";
// import { initializeApp, FirebaseApp } from "firebase/app";
import { IUserInfo, IBIndInfo, TVideoWhiteStatus } from "./types";
import {
  bindEmail,
  bindMobile,
  bindThirdParty,
  emailLogin,
  getBindInfo,
  getUserInfo,
  mobileLogin,
  thirdPartyLogin,
  unbindEmail,
  unbindMobile,
  getWaterMark,
  logout,
  logoff,
  resetPassword,
  initPassword,
  editPassword,
  modifyModelSwitch,
} from "../../services/auth";
import { MODEL_SWITCH, ResCode } from "logic/src/constants/request";

export class User {
  @observable isLogin = false;
  @observable userInfo: null | IUserInfo = null;
  // @observable firebaseApp: FirebaseApp;
  @observable watermark: string = "";
  @observable bindInfo: null | IBIndInfo = null;

  @observable videoWhitelistStatus: TVideoWhiteStatus | null = "authorized"; // 默认值为已经授权 authorized

  public constructor() {
    makeObservable(this);
    this.isLogin =
      !!localStorage.getItem("accessToken") &&
      localStorage.getItem("accessToken") !== "undefined";
    // this.firebaseApp = initializeApp(firebaseConfig);
    // console.log("this.firebaseApp", this.firebaseApp);
    this.setToken = this.setToken.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
    if (this.isLogin) {
      this.checkVideoWhiteList();
    }

    // this.googleLogin = this.googleLogin.bind(this);
    // this.unbindThirdParty = this.unbindThirdParty.bind(this);
  }

  @action
  setVideoWhitelistStatus(v: TVideoWhiteStatus | null) {
    this.videoWhitelistStatus = v;
  }

  @action.bound
  setNeedInitPasswd(value: boolean) {
    if (this.userInfo !== null) {
      this.userInfo.need_init_passwd = value;
    } else {
      throw Error("userInfo is null");
    }
  }

  // @flow
  // public *googleLogin(): any {
  //   console.log("googleLogin");
  //   const auth = getAuth(this.firebaseApp);
  //   const provider = new GoogleAuthProvider();
  //   provider.setCustomParameters({
  //     prompt: "select_account",
  //   });
  //   const result = yield signInWithPopup(auth, provider);
  //   const idToken = yield auth.currentUser?.getIdToken(true);
  //   if (idToken) {
  //     const uid = result.user.uid;
  //     if (idToken && uid) {
  //       yield this.loginFromThirdParty({
  //         id: uid,
  //         token: idToken,
  //         platform: "google",
  //       });
  //     }
  //   }
  // }

  // @flow
  // public *appleLogin(): any {
  //   const auth = getAuth(this.firebaseApp);
  //   const provider = new OAuthProvider("apple.com");
  //   provider.setCustomParameters({
  //     prompt: "select_account",
  //   });
  //   const result = yield signInWithPopup(auth, provider);
  //   const idToken = yield auth.currentUser?.getIdToken(true);
  //   if (idToken) {
  //     const uid = result.user.uid;
  //     if (idToken && uid) {
  //       yield this.loginFromThirdParty({
  //         id: uid,
  //         token: idToken,
  //         platform: "apple",
  //       });
  //     }
  //   }
  // }

  @flow
  public *loginFromThirdParty(params: {
    platform: string;
    id: string;
    token: string;
  }): any {
    const res = yield thirdPartyLogin(params);
    console.log("thrid party login res", res);
    yield this.setToken(res.message.access ?? "", res.message.refresh ?? "");
    console.log("thrid party login");
  }

  @flow
  public *loginByEmail(params: { email: string; email_code: string }): any {
    const res = yield emailLogin(params);
    if (res.code === ResCode.Success) {
      yield this.setToken(res.message.access ?? "", res.message.refresh ?? "");
      console.log("email login");
    } else {
      throw res;
    }
  }

  @flow
  public *loginByMobil(params: {
    mobile: string;
    sms_code?: string;
    password?: string;
  }): any {
    const res = yield mobileLogin(params);
    if (res.code === ResCode.Success) {
      yield this.setToken(res.message.access ?? "", res.message.refresh ?? "");
    } else {
      throw res;
    }
  }

  @flow
  public *setToken(accessToken: string, refreshToken: string) {
    try {
      yield Promise.all([
        sensecommon.setToken("accessToken", accessToken),
        sensecommon.setToken("refreshToken", refreshToken),
      ]);
      this.isLogin = true;
    } catch (error) {
      console.log("set token error", error);
    }
  }

  @flow
  public *getUserInfo(): any {
    try {
      if (!this.isLogin) {
        return;
      }
      const userInfo = yield getUserInfo();
      this.userInfo = {
        ...(userInfo.message || {}),
      };
      // yield this.getUserBindInfo();
    } catch (error) {
      throw error;
    }
  }

  @flow
  public *getWaterMark(): any {
    try {
      if (!this.isLogin) {
        return;
      }
      const {
        message: { watermark },
      } = yield getWaterMark();
      this.watermark = watermark;
    } catch (error) {
      throw error;
    }
  }

  @flow
  public *getUserBindInfo(): any {
    try {
      const bindInfo = yield getBindInfo({
        Authorization: yield sensecommon.getToken("accessToken"),
      });
      console.log("bind info", bindInfo);
      this.bindInfo = {
        ...(bindInfo.message || {}),
      };
    } catch (error) {
      throw error;
    }
  }

  // @flow
  // public *bindThirdParty(
  //   platform: string,
  //   onSuccess: () => void,
  //   onFailure: () => void,
  // ): any {
  //   try {
  //     const auth = getAuth(this.firebaseApp);
  //     let result;
  //     if (platform === "google") {
  //       const provider = new GoogleAuthProvider();
  //       provider.setCustomParameters({
  //         prompt: "select_account",
  //       });
  //       result = yield signInWithPopup(auth, provider);
  //     } else {
  //       const provider = new OAuthProvider("apple.com");
  //       provider.setCustomParameters({
  //         prompt: "select_account",
  //       });
  //       result = yield signInWithPopup(auth, provider);
  //     }

  //     if (result && auth.currentUser) {
  //       const token = yield auth.currentUser?.getIdToken(true);
  //       const id = result.user.uid;
  //       const res = yield bindThirdParty({
  //         platform,
  //         id,
  //         token,
  //       });
  //       if (res.code === ResCode.Success) {
  //         yield this.getUserBindInfo();
  //       } else {
  //         throw res;
  //       }
  //       onSuccess();
  //     } else {
  //       throw Error();
  //     }
  //   } catch (error) {
  //     console.log("bind error", error);
  //     onFailure();
  //   }
  // }

  // @flow
  // public *unbindThirdParty({
  //   platform,
  //   id,
  //   onSuccess,
  //   onFailure,
  // }: {
  //   platform: string;
  //   id: string;
  //   onSuccess: () => void;
  //   onFailure: () => void;
  // }): any {
  //   try {
  //     const auth = getAuth(this.firebaseApp);
  //     onAuthStateChanged(auth, async user => {
  //       let token: string;
  //       if (user) {
  //         token = await user.getIdToken(true);
  //       } else {
  //         const auth = getAuth(this.firebaseApp);
  //         let provider;
  //         if (platform === "google") {
  //           provider = new GoogleAuthProvider();
  //         } else {
  //           provider = new OAuthProvider("apple.com");
  //         }
  //         provider.setCustomParameters({
  //           prompt: "select_account",
  //         });
  //         const result = await signInWithPopup(auth, provider);
  //         token = await result.user.getIdToken(true);
  //       }
  //       console.log("unbind third party", token, id);
  //       const res = await unbindThirdParty({
  //         platform,
  //         id,
  //         token,
  //       });
  //       if (res.code !== ResCode.Success) {
  //         onFailure();
  //         throw Error(res.error);
  //       }
  //       await this.getUserBindInfo();
  //       onSuccess();
  //     });
  //   } catch (error) {
  //     onFailure();
  //     console.log("unbind error", error);
  //   }
  // }

  @flow
  public *bindMobile(params: { mobile: string; sms_code: string }): any {
    try {
      const res = yield bindMobile(params);
      if (res.code !== ResCode.Success) {
        throw Error(res.error);
      }
      yield this.getUserBindInfo();
    } catch (error) {
      console.log("bind error", error);
      throw error;
    }
  }

  @flow
  public *unbindMobile(params: { mobile: string; sms_code: string }): any {
    try {
      const res = yield unbindMobile(params);
      if (res.code !== ResCode.Success) {
        throw Error(res.error);
      }
      yield this.getUserBindInfo();
    } catch (error) {
      console.log("bind error", error);
      throw error;
    }
  }

  @flow
  public *bindEmail(params: { email: string; code: string }): any {
    try {
      const res = yield bindEmail(params);
      if (res.code !== ResCode.Success) {
        throw Error(res.error);
      }
      yield this.getUserBindInfo();
    } catch (error) {
      console.log("bind error", error);
      throw error;
    }
  }

  @flow
  public *unbindEmail(params: { email: string; code: string }): any {
    try {
      const res = yield unbindEmail(params);
      if (res.code !== ResCode.Success) {
        throw Error(res.error);
      }
      yield this.getUserBindInfo();
    } catch (error) {
      console.log("bind error", error);
      throw error;
    }
  }

  @flow.bound
  public *logout(): any {
    const res = yield logout();
    if (res.code === ResCode.Success) {
      // const auth = getAuth(this.firebaseApp);
      // yield signOut(auth);
      sensecommon.setToken("accessToken", "");
      sensecommon.setToken("refreshToken", "");
      this.isLogin = false;
    } else {
      throw res;
    }
  }

  @flow.bound
  public *logoff(): any {
    const res = yield logoff();
    if (res.code === ResCode.Success) {
      // const auth = getAuth(this.firebaseApp);
      // yield signOut(auth);
      sensecommon.setToken("accessToken", "");
      sensecommon.setToken("refreshToken", "");
      this.isLogin = false;
    } else {
      throw res;
    }
  }

  @flow.bound
  public *resetPassword(value: {
    mobile: string;
    sms_code: string;
    password: string;
    confirm: string;
  }): any {
    const res = yield resetPassword(value);
    if (res.code !== ResCode.Success) {
      throw res;
    }
  }

  @flow.bound
  public *initPassword(value: { password: string; confirm: string }): any {
    const res = yield initPassword(value);
    if (res.code !== ResCode.Success) {
      throw res;
    }
  }

  @flow.bound
  public *editPassword(value: { origin: string; password: string }): any {
    const res = yield editPassword(value);
    if (res.code !== ResCode.Success) {
      throw res;
    }
  }

  @flow.bound
  public *switchModel(value: MODEL_SWITCH): any {
    const res = yield modifyModelSwitch({ model_switch: value });
    if (res.code !== ResCode.Success) {
      throw res;
    }
    this.userInfo && (this.userInfo.model_switch = value);
  }

  async checkVideoWhiteList() {
    // if (
    //   this.videoWhitelistStatus === "authorized" ||
    //   this.videoWhitelistStatus === "unauthorized"
    // ) {
    //   return this.videoWhitelistStatus;
    // }
    try {
      const res = await checkVideoEditWhitelist();
      if (res.code === 0) {
        // const { status } = res.message;
        // this.setVideoWhitelistStatus(status);
        // return status;
        return "authorized"; // 直接返回 authorized';

        // if (status === "applying") {
        //   // 已提交申请，正在审核，使用messageApi显示消息
        //   messageApi.success("您的申请正在审核中，请耐心等待");
        // } else if (status === "unauthorized") {
        //   // 无权限且未申请，显示申请试用弹窗
        //   setShowApplyDialog(true);
        // } else if (status === "authorized") {
        //   // 有权限，跳转到视频理解页面
        //   navigate("/videoUnderstanding");
        // }
      } else {
        throw new Error("请求失败");
      }
    } catch (error) {
      return "";
    }
  }
}

export default new User();
